import { jsx as M } from "react/jsx-runtime";
import { c as y } from "react/compiler-runtime";
import { useState as B, useRef as z, useEffect as C } from "react";
import { Box as D } from "@mui/material";
import { styles as L } from "./styles.js";
function H(X) {
  const e = y(19), {
    columnId: n,
    onResize: v,
    onResizeStart: R,
    onResizeEnd: h
  } = X, [t, E] = B(!1), r = z(null), o = z(null), x = z(null);
  let s;
  e[0] !== n || e[1] !== R ? (s = (w) => {
    w.preventDefault(), E(!0), R(n);
    const p = x.current?.parentElement;
    p && (r.current = w.clientX, o.current = p.getBoundingClientRect().width);
  }, e[0] = n, e[1] = R, e[2] = s) : s = e[2];
  const g = s;
  let l;
  e[3] !== n || e[4] !== t || e[5] !== v ? (l = (w) => {
    if (!t || r.current === null || o.current === null)
      return;
    const p = w.clientX - r.current, S = Math.max(50, o.current + p);
    v(n, S);
  }, e[3] = n, e[4] = t, e[5] = v, e[6] = l) : l = e[6];
  const i = l;
  let u;
  e[7] !== t || e[8] !== h ? (u = () => {
    t && (E(!1), h(), r.current = null, o.current = null);
  }, e[7] = t, e[8] = h, e[9] = u) : u = e[9];
  const c = u;
  let f;
  e[10] !== i || e[11] !== c || e[12] !== t ? (f = () => (t && (window.addEventListener("mousemove", i), window.addEventListener("mouseup", c)), () => {
    window.removeEventListener("mousemove", i), window.removeEventListener("mouseup", c);
  }), e[10] = i, e[11] = c, e[12] = t, e[13] = f) : f = e[13];
  let m;
  e[14] !== t ? (m = [t], e[14] = t, e[15] = m) : m = e[15], C(f, m);
  let a;
  e[16] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ M(D, { sx: {
    ...L.resizerHandle
  } }), e[16] = a) : a = e[16];
  let d;
  return e[17] !== g ? (d = /* @__PURE__ */ M(D, { ref: x, sx: L.columnResizer, onMouseDown: g, children: a }), e[17] = g, e[18] = d) : d = e[18], d;
}
export {
  H as ColumnResizer
};
